const AuthInfoObj = () => {
  const session = sessionStorage.getItem("session");
  const sessionID = sessionStorage.getItem("sessionID");
  const userID = sessionStorage.getItem("userID");
  return {
    session: session,
    sessionID: sessionID,
    userID: userID,
  };
};

export default AuthInfoObj;
